import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Button } from '@/components/atoms/Buttons';
import type { LoginOptions } from '@/domain/auth';

import styles from '../Login.module.scss';

interface LoginProviderStepProps {
    authOptions: LoginOptions | null;
    onProviderLogin: (provider: string) => void;
    onUseDifferentEmail: () => void;
}

export default function LoginProviderStep(props: LoginProviderStepProps) {
    const { authOptions, onProviderLogin, onUseDifferentEmail } = props;
    const { t } = useTranslation();

    return (
        <div>
            <div className={styles.providerList}>
                {authOptions?.authProviders.map((provider) => (
                    <Button
                        key={provider.name}
                        size={'large'}
                        fullWidth
                        className={classNames(
                            styles.providerButton,
                            'provider-btn',
                            `provider-${provider.name.toLowerCase()}`
                        )}
                        onClick={() => onProviderLogin(provider.name)}>
                        {provider.name === 'microsoft' &&
                            `${t('publicPages.login.signInWithMicrosoftWork')}`}
                        {provider.name === 'google' &&
                            `${t('publicPages.login.signInWith')} Google`}
                        {provider.name === 'local' &&
                            `${t('publicPages.login.signInWith')} ${t('publicPages.login.emailPassword')}`}
                    </Button>
                ))}
            </div>
            <div className={styles.secondaryAction}>
                <Button variant="link" className={styles.inverseLink} onClick={onUseDifferentEmail}>
                    {t('publicPages.login.useADifferentEmail')}
                </Button>
            </div>
        </div>
    );
}
